/* ============================================================
   SPEEDY'S PARTS — SHOP BY BRAND MENU
   Brand row -> part types (live counts) -> live product cards.
   Data source: /collections/<brand-handle>/products.json — the
   live storefront feed. No snapshots. Deleted/unpublished
   products can never appear; stock/price/title always current.
   Session cache: 15 minutes per brand. Staff: ?sp-bm-staff=1
   shows sold-out regardless of the customizer setting.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('sp-brand-menu');
  if (!root) return;

  /* ---------------- config ---------------- */
  var CFG = {
    cols: parseInt(root.getAttribute('data-columns'), 10) || 4,
    maxInitial: parseInt(root.getAttribute('data-max-initial'), 10) || 8,
    showImages: root.getAttribute('data-show-images') !== 'false',
    showPrices: root.getAttribute('data-show-prices') !== 'false',
    showSoldout: root.getAttribute('data-show-soldout') === 'true',
    maxHeight: parseInt(root.getAttribute('data-max-height'), 10) || 560,
    currency: root.getAttribute('data-currency') || 'USD'
  };
  CFG.requireTag = (root.getAttribute('data-require-tag') || '').trim();
  CFG.dedupeSkus = root.getAttribute('data-dedupe-skus') !== 'false';
  var STAFF = /[?&]sp-bm-staff=1/.test(window.location.search);
  if (STAFF) { CFG.showSoldout = true; CFG.requireTag = ''; CFG.dedupeSkus = false; }

  var TTL = 15 * 60 * 1000;
  var MAX_PAGES = 4;
  var DISPLAY = {
    'Electric / General Motor': 'Electric Motors',
    'Hydraulic / Control Valve': 'Hydraulic & Control Valves',
    'Pump - Other': 'Specialty Pumps',
    'Valve - Other': 'Valves',
    'Electronic Control Module (ECM/ECU)': 'ECM / ECU Modules',
    'Pumps - Other': 'Pumps & Fluid Handling'
  };

  /* ---------------- runtime title classifier ----------------
     Same 170-rule engine used for the tag imports, compiled in-browser.
     Products with no pt: tag get classified from their TITLE at render
     time — so stale variant IDs or products no import ever touched still
     land in the right category. First matching rule wins. */
  var TITLE_RULES_RAW = [["fuel injection pump|injection pump|injector pump","Fuel Injection Pumps"],["injector sleeve|injector tube|injector cup","Injector Sleeves"],["\\binjectors?\\b|injection nozzle|injector nozzle|\\bnozzles?\\b.*(fuel|inject)|(fuel|inject).*\\bnozzles?\\b","Fuel Injectors"],["glow plug","Glow Plugs"],["fuel filter|water separator","Fuel Filters"],["fuel (transfer|lift|feed) pump|lift pump|fuel pump|fuel supply pump","Fuel Pumps"],["fuel rail","Fuel Rails"],["carburetor|carb\\b","Carburetors"],["fuel tank","Fuel Tanks"],["fuel (line|hose)","Fuel Lines"],["fuel (shut ?off|solenoid|valve)","Fuel Shutoff & Valves"],["fuel (sender|sending|level)","Fuel Senders"],["turbo(charger)? actuator|wastegate actuator|vgt actuator","Turbo Actuators"],["turbo(charger)?s?\\b|turbo cartridge|chra","Turbochargers"],["egr cooler","EGR Coolers"],["egr valve|egr\\b","EGR Valves"],["dpf|diesel particulate","DPF & Aftertreatment"],["\\bdoc\\b.*(filter|catalyst)|catalytic|catalyst","DPF & Aftertreatment"],["\\bdef\\b|scr\\b|adblue|urea|nox sensor","DEF / SCR Components"],["muffler|exhaust (pipe|elbow|stack|clamp|gasket|manifold)|exhaust\\b","Exhaust & Mufflers"],["intercooler|charge air cooler|\\bcac\\b","Charge Air Coolers"],["intake manifold|inlet manifold","Intake Manifolds"],["air filter|air cleaner|precleaner|pre-cleaner","Air Filters"],["air (compressor|governor)","Air Compressors"],["air dryer","Air Dryers"],["breather","Breathers"],["alternator|generator","Alternators & Generators"],["starter|cranking motor","Starters"],["wire harness|wiring harness|\\bharness\\b","Wiring Harnesses"],["\\becm\\b|\\becu\\b|engine control (module|unit)","ECM / ECU Modules"],["joystick|multifunction control","Joysticks & Controls"],["monitor|display|console|touchscreen|instrument cluster","Displays & Monitors"],["\\bcamera\\b","Cameras"],["control module|controller|control unit|\\bmodule\\b","Control Modules"],["solenoid valve|solenoid.*valve","Solenoid Valves"],["solenoid","Solenoids"],["\\brelays?\\b","Relays"],["ignition coil|coil pack","Ignition Coils"],["spark plug","Spark Plugs"],["ignition","Ignition Components"],["(pressure|oil pressure) (sensor|sender|switch)","Pressure Sensors & Switches"],["(temp|temperature|coolant temp) (sensor|sender|switch)","Temperature Sensors"],["(speed|rpm|cam|crank|crankshaft|camshaft) sensor","Speed & Position Sensors"],["(position|angle|height|level) sensor","Speed & Position Sensors"],["o2 sensor|oxygen sensor","DEF / SCR Components"],["\\bsensors?\\b|\\bsenders?\\b|sending unit","Sensors"],["\\bswitch(es)?\\b","Switches"],["battery|batteries","Batteries"],["light bar|work light|headlight|head lamp|tail (light|lamp)|\\blamp\\b|\\bled\\b|beacon|\\blights?\\b","Lighting"],["gauge|tachometer|speedometer|hour meter|hourmeter","Gauges & Meters"],["fuse\\b|fuse holder","Fuses & Holders"],["circuit breaker","Circuit Breakers"],["contactor","Contactors"],["(vfd|variable frequency|frequency) drive|ac drive|inverter drive|\\binverter\\b","VFD & Drives"],["soft start(er)?","Soft Starters"],["encoder","Encoders"],["transformer","Transformers"],["capacitor","Capacitors"],["(gps|starfire) (receiver|antenna)|receiver|antenna","GPS & Receivers"],["horn\\b","Horns & Alarms"],["back-?up alarm|backup alarm","Horns & Alarms"],["hydraulic motor|orbit motor|gerotor motor|wheel motor|swing motor|drive motor.*hydraulic|hydrostatic motor","Hydraulic Motors"],["servo motor","Servo Motors"],["gear ?motor|gearmotor","Gearmotors"],["blower motor","Blower Motors"],["wiper motor","Wiper Motors"],["fan motor","Fan Motors"],["(electric|ac|dc|induction|three.?phase|single.?phase)\\b.*\\bmotor|\\bmotor\\b.*(hp|rpm|volt|phase|tefc|odp)|electric motor","Electric Motors"],["hydrostatic (pump|drive|transmission)|hydro.?static","Hydrostatic Drives & Pumps"],["hydraulic pump|(piston|gear|vane|axial|radial) pump","Hydraulic Pumps"],["hydraulic cylinder|(lift|boom|bucket|tilt|stabilizer|loader|dipper|arm|blade) cylinder","Hydraulic Cylinders"],["(hydraulic|control|relief|check|spool|directional|selective|scv|priority|flow) valve|valve (section|assembly|block)","Hydraulic & Control Valves"],["hydraulic filter|hyd\\.? filter","Hydraulic Filters"],["hydraulic (hose|line)","Hydraulic Hoses"],["accumulator","Accumulators"],["hydraulic (tank|reservoir)","Hydraulic Reservoirs"],["quick coupler|quick connect|hydraulic coupler","Quick Couplers"],["final drive","Final Drives"],["pneumatic (valve|cylinder)|air valve|air cylinder","Pneumatic Valves & Cylinders"],["steering (gear|box)","Steering Gears"],["(power )?steering pump","Steering Pumps"],["steering (cylinder|ram)","Steering Cylinders"],["(orbitrol|orbital|steering) (valve|unit)|steering control unit","Steering Valves"],["tie rod|drag link|steering (arm|shaft|column|wheel|knuckle)","Steering Components"],["brake (pad|shoe|lining)","Brake Pads & Shoes"],["brake (rotor|drum|disc)\\b","Brake Rotors & Drums"],["brake caliper","Brake Calipers"],["brake chamber","Brake Chambers"],["slack adjuster","Slack Adjusters"],["(master|wheel) cylinder","Master & Wheel Cylinders"],["brake valve","Brake Valves"],["\\bbrake\\b|abs\\b","Brake Components"],["torque converter","Torque Converters"],["pto (clutch|shaft|assembly)|\\bpto\\b|power take.?off","PTO Components"],["clutch (kit|disc|disk|plate|assembly|pack)|\\bclutch\\b","Clutches"],["transmission|transaxle|gear ?shift|shift (kit|fork|lever)","Transmissions & Parts"],["(universal )?drive ?shaft|driveline|prop shaft","Driveshafts"],["universal joint|u-?joint|cross (and|&) bearing","U-Joints"],["differential|ring (and|&) pinion|\\bdiff\\b","Differentials"],["axle","Axles & Components"],["gear ?box|gear (reducer|drive|head)|speed reducer|\\breducer\\b","Gearboxes & Reducers"],["sprocket","Sprockets"],["\\bchains?\\b","Chains"],["coupling|coupler\\b|love ?joy","Couplings"],["sheave|pulley","Sheaves & Pulleys"],["(wheel )?hub\\b|hub assembly","Hubs"],["planet(ary)? (gear|carrier|pinion)|sun gear|\\bgears?\\b|\\bpinion\\b","Gears & Pinions"],["camshaft","Camshafts"],["crankshaft","Crankshafts"],["cylinder head","Cylinder Heads"],["piston.?liner kit|liner kit|piston kit|\\bpistons?\\b|cylinder liner|\\bliners?\\b|sleeve assembly","Pistons & Liners"],["connecting rod|con rod","Connecting Rods"],["rocker arm","Rocker Arms"],["lifter|tappet|cam follower","Lifters & Tappets"],["(engine|intake|exhaust) valve\\b|valve (guide|seat|spring|stem)","Engine Valvetrain"],["timing (cover|gear|chain|belt|case)","Timing Components"],["harmonic balancer|(vibration|torsional) damper|crankshaft damper","Dampers & Balancers"],["oil pan\\b","Oil Pans"],["oil pump","Oil Pumps"],["oil cooler","Oil Coolers"],["oil filter","Oil Filters"],["(overhaul|rebuild|inframe|in-frame) kit","Engine Overhaul Kits"],["flywheel housing","Flywheel Housings"],["flywheel","Flywheels"],["(motor|engine) mount","Engine Mounts"],["front cover|gear cover|timing housing","Engine Covers & Housings"],["valve cover|rocker cover","Valve Covers"],["dip ?stick","Dipsticks & Tubes"],["engine speed control|throttle","Throttle & Speed Controls"],["radiator","Radiators"],["water pump|coolant pump","Water Pumps"],["thermostat","Thermostats"],["fan (clutch|drive)","Fan Clutches"],["fan (blade|assembly)|cooling fan|\\bfan\\b","Cooling Fans"],["(surge|expansion|coolant|overflow) tank|recovery tank","Coolant Tanks"],["block heater|engine heater","Block Heaters"],["scroll compressor","Scroll Compressors"],["(a/?c|air condition\\w*) compressor|compressor.*(r134|r404|r22|refrigerant)|semi-?hermetic|discus|copelam[ei]tic","Refrigeration & A/C Compressors"],["\\bcompressors?\\b","Refrigeration & A/C Compressors"],["condenser","Condensers"],["evaporator","Evaporators"],["expansion valve|txv","Expansion Valves"],["filter drier|receiver drier","Filter Driers"],["heater core|heater valve|cab heater|\\bheater\\b","Heaters"],["a/?c clutch|compressor clutch","A/C Clutches"],["pillow block","Pillow Block Bearings"],["bearing kit|\\bbearings?\\b|tapered roller|ball bearing|needle bearing|cam follower bearing","Bearings"],["bushing","Bushings"],["belt tensioner|tensioner|idler (pulley|arm)","Tensioners & Idlers"],["v-?belt|drive belt|serpentine|\\bbelts?\\b","Belts"],["seal kit","Seal Kits"],["gasket (set|kit)|head gasket|\\bgaskets?\\b","Gaskets"],["o-?ring","O-Rings"],["oil seal|\\bseals?\\b","Seals"],["filter (kit|set)|\\bfilters?\\b","Filters"],["\\bhoses?\\b","Hoses"],["fitting|adapter|elbow\\b|\\btee\\b|nipple","Fittings & Adapters"],["\\btubes?\\b|\\blines?\\b|\\bpipes?\\b","Tubes & Lines"],["grease (pump|gun)|lubric\\w+ (pump|system)|metering pump","Lubrication Equipment"],["\\bpumps?\\b","Pumps"],["linear actuator|actuator","Actuators"],["shock absorber|\\bshocks?\\b|strut","Shocks & Struts"],["leaf spring|coil spring|air spring|air bag|\\bsprings?\\b","Springs & Air Bags"],["control arm|ball joint|sway bar|stabilizer bar","Suspension Components"],["king ?pin","King Pins"],["track (roller|link|chain|shoe|adjuster)|undercarriage|bottom roller|top roller|idler\\b","Undercarriage"],["wheel stud|lug nut|\\brims?\\b|\\bwheels?\\b","Wheels & Hardware"],["mirror","Mirrors"],["windshield|window|glass\\b","Glass & Windshields"],["\\bseats?\\b|seat (belt|cushion|back)","Seats & Belts"],["wiper (blade|arm)","Wipers"],["door (handle|latch|hinge|panel)|latch|hinge","Latches & Hinges"],["hood\\b|fender|grille|bumper|cowl|panel\\b|step\\b|mud ?flap","Body Panels & Trim"],["decal|emblem|sticker","Decals & Emblems"],["floor mat|weather ?strip","Cab Interior"],["\\bcab\\b","Cab Components"],["bucket (tooth|teeth)|cutting edge|blade\\b|auger|fork(s)?\\b|grapple","Attachments & Wear Parts"],["air (intake )?duct|intake (duct|pipe|hose)|air intake","Air Intake Components"],["mower deck|cutting unit|reel\\b|mower\\b","Mower & Cutting Parts"],["(lift|float|bucket|loader|boom|dipper) arm|arm link|linkage|feeder house|draper","Loader & Linkage Components"],["control lever|\\blevers?\\b","Levers & Controls"],["doc converter|\\bconverter\\b","DPF & Aftertreatment"],["(short|long) block|engine assembly|crate engine|half engine","Engine Assemblies & Blocks"],["common rail","Fuel Rails"],["heat exchanger","Heat Exchangers"],["blower assembly|\\bblowers?\\b","Blowers"],["fuel cooler","Fuel Coolers"],["(tail|track|deck) roller|\\brollers?\\b","Rollers"],["clamp","Clamps"],["shroud","Covers & Shields"],["sway block|stop block|weight (support|bracket)|counterweight|ballast","Weights & Supports"],["manifold","Hydraulic Manifolds"],["\\bcylinders?\\b","Hydraulic Cylinders"],["\\bframes?\\b|support\\b","Frames & Supports"],["\\bgrilles?\\b|\\bscreens?\\b","Body Panels & Trim"],["idle air control|\\biac\\b","Throttle & Speed Controls"],["low speed high torque|orbital motor|hydraulic \\w+ motor","Hydraulic Motors"],["transmitter|remote indicator|gas detector|\\bdetector\\b","Sensors"],["vehicle mounted computer|mobile computer","Displays & Monitors"],["(gas|pilot|butterfly|dispensing|piloted|zone|mixing) valve","Industrial & Gas Valves"],["variable volume|\\bvav\\b|air handler|packaged unit","HVAC Units & Components"],["(general purpose|replacement|blower|condenser fan) motor","Electric Motors"],["grease jockey|grease system|\\bgrease\\b|lubricat","Lubrication Equipment"],["oil sump","Oil Pans"],["service system|recovery machine|recycling machine","Tools & Testers"],["ratio\\b.*(pump|inlet)|diaphragm pump|transfer pump","Pumps"],["\\bvalves?\\b","Industrial & Gas Valves"],["\\bmotors?\\b","Electric Motors"],["housing","Housings"],["bracket|mount(ing)? (kit|bracket)|\\bmounts?\\b","Brackets & Mounts"],["\\bshafts?\\b|spindle","Shafts & Spindles"],["\\bknobs?\\b|\\bhandles?\\b|\\bcaps?\\b|\\bplugs?\\b|\\bbolts?\\b|\\bscrews?\\b|\\bnuts?\\b|washer","Hardware"],["\\bkits?\\b","Repair Kits"],["\\btools?\\b|tester|wrench|gauge set","Tools & Testers"],["\\btanks?\\b|reservoir","Tanks & Reservoirs"],["\\bcables?\\b|battery cable|throttle cable","Cables"],["\\bcovers?\\b|shield|guard","Covers & Shields"]];
  var TITLE_RULES = [];
  (function () {
    for (var i = 0; i < TITLE_RULES_RAW.length; i++) {
      try { TITLE_RULES.push([new RegExp(TITLE_RULES_RAW[i][0], 'i'), TITLE_RULES_RAW[i][1]]); } catch (e) {}
    }
  })();
  var titleClassify = function (title) {
    for (var i = 0; i < TITLE_RULES.length; i++) {
      if (TITLE_RULES[i][0].test(title)) return TITLE_RULES[i][1];
    }
    return null;
  };
  var normSku = function (s) { return String(s || '').toUpperCase().replace(/[^A-Z0-9]+/g, ''); };

  var moreBrands = [];
  try { moreBrands = JSON.parse(document.getElementById('sp-bm-more-brands').textContent) || []; } catch (e) {}

  var panel = root.querySelector('.sp-bm-panel');
  var triggers = root.querySelectorAll('.sp-bm-trigger');
  var sheet = document.getElementById('sp-bm-sheet');
  var mobileOpen = document.getElementById('sp-bm-mobile-open');
  panel.style.setProperty('--sp-bm-maxh', CFG.maxHeight + 'px');

  /* ---------------- utils ---------------- */
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  };
  var money = function (v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: CFG.currency }).format(n); }
    catch (e) { return '$' + n.toFixed(2); }
  };
  var handleize = function (s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };
  var displayName = function (raw) { return DISPLAY[raw] || raw; };
  var imgUrl = function (src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  };

  /* ---------------- live data ---------------- */
  var mem = {};
  var cacheGet = function (handle) {
    if (mem[handle]) return mem[handle];
    try {
      var raw = sessionStorage.getItem('sp-bm-' + handle);
      if (!raw) return null;
      var obj = JSON.parse(raw);
      if (Date.now() - obj.t > TTL) return null;
      mem[handle] = obj.p;
      return obj.p;
    } catch (e) { return null; }
  };
  var cacheSet = function (handle, products) {
    mem[handle] = products;
    try { sessionStorage.setItem('sp-bm-' + handle, JSON.stringify({ t: Date.now(), p: products })); } catch (e) {}
  };

  var loadBrand = function (handle, cb, err) {
    var cached = cacheGet(handle);
    if (cached) { cb(cached); return; }
    var out = [];
    var page = 1;
    var next = function () {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          var items = (j && j.products) || [];
          for (var i = 0; i < items.length; i++) {
            var p = items[i];
            var available = false, price = null;
            for (var v = 0; v < (p.variants || []).length; v++) {
              if (p.variants[v].available) available = true;
              var pv = parseFloat(p.variants[v].price);
              if (!isNaN(pv) && (price === null || pv < price)) price = pv;
            }
            out.push({
              title: p.title,
              url: '/products/' + p.handle,
              img: (p.images && p.images[0] && p.images[0].src) || '',
              price: price,
              available: available,
              sku: (p.variants && p.variants[0] && p.variants[0].sku) || '',
              tags: p.tags || []
            });
          }
          if (items.length === 250 && page < MAX_PAGES) { page++; next(); }
          else { cacheSet(handle, out); cb(out); }
        })
        .catch(function (e) { if (out.length) { cacheSet(handle, out); cb(out); } else { err(e); } });
    };
    next();
  };

  /* per-brand part types from live tags -> flat list ranked by product count.
     The brand's collection feed only contains that brand's products, so this
     ranking is that brand's own top types (John Deere's, not the catalog's). */
  var TOP_TYPES = 20;
  var buildTree = function (products) {
    /* Dedupe filter: only products carrying the required tag (default main1).
       Safety: if NOTHING in this brand's feed has the tag yet (staging import
       not run), the filter stands down instead of blanking the brand. */
    var req = CFG.requireTag;
    if (req) {
      var anyTagged = false;
      for (var a = 0; a < products.length; a++) {
        if (products[a].tags.indexOf(req) > -1) { anyTagged = true; break; }
      }
      if (!anyTagged) req = '';
    }
    var visible = [];
    for (var i = 0; i < products.length; i++) {
      if (!CFG.showSoldout && !products[i].available) continue;
      if (req && products[i].tags.indexOf(req) === -1) continue;
      visible.push(products[i]);
    }
    /* duplicate-listing collapse: same SKU ignoring punctuation (K2907 == K-2907)
       keeps the in-stock copy; works even before any main1 tags exist */
    if (CFG.dedupeSkus) {
      var bySku = {}, deduped = [];
      for (var d = 0; d < visible.length; d++) {
        var key = normSku(visible[d].sku);
        if (!key) { deduped.push(visible[d]); continue; }
        var seen = bySku[key];
        if (seen === undefined) { bySku[key] = deduped.length; deduped.push(visible[d]); }
        else if (!deduped[seen].available && visible[d].available) { deduped[seen] = visible[d]; }
      }
      visible = deduped;
    }
    var byPt = {};
    for (var j = 0; j < visible.length; j++) {
      var p = visible[j];
      var pt = null;
      for (var t = 0; t < p.tags.length; t++) {
        if (p.tags[t].indexOf('pt:') === 0) { pt = p.tags[t].slice(3); break; }
      }
      if (!pt) pt = titleClassify(p.title);
      if (!pt) pt = 'Uncategorized';
      if (!byPt[pt]) byPt[pt] = { raw: pt, name: displayName(pt), products: [] };
      byPt[pt].products.push(p);
    }
    var list = [];
    for (var k in byPt) list.push(byPt[k]);
    /* buckets sink to the bottom of the rail regardless of size */
    var sink = function (e) { return e.raw === 'Uncategorized' ? 2 : (e.raw === 'Miscellaneous Parts' ? 1 : 0); };
    list.sort(function (a, b) {
      var s = sink(a) - sink(b);
      return s !== 0 ? s : b.products.length - a.products.length;
    });
    return { list: list, total: visible.length };
  };

  /* ---------------- desktop panel ---------------- */
  var activeBtn = null;
  var currentHandle = null; /* which brand the panel is loading/showing */

  var closePanel = function () {
    panel.hidden = true;
    panel.innerHTML = '';
    currentHandle = null;
    if (activeBtn) { activeBtn.setAttribute('aria-expanded', 'false'); activeBtn.classList.remove('is-active'); }
    activeBtn = null;
  };

  var openFor = function (btn) {
    if (activeBtn === btn) { closePanel(); return; }
    if (activeBtn) { activeBtn.setAttribute('aria-expanded', 'false'); activeBtn.classList.remove('is-active'); }
    activeBtn = btn;
    btn.setAttribute('aria-expanded', 'true');
    btn.classList.add('is-active');
    panel.hidden = false;
    if (btn.getAttribute('data-more')) renderMoreBrands();
    else renderBrandLoading(btn.getAttribute('data-brand'), btn.getAttribute('data-handle'));
  };

  var renderBrandLoading = function (brand, handle) {
    currentHandle = handle;
    var sk = '';
    for (var i = 0; i < CFG.maxInitial; i++) sk += '<div class="sp-bm-skel-card"></div>';
    panel.innerHTML =
      '<div class="sp-bm-grid">' +
        '<div class="sp-bm-pts"><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div></div>' +
        '<div class="sp-bm-prods"><div class="sp-bm-cards" style="--sp-bm-cols:' + CFG.cols + ';">' + sk + '</div></div>' +
      '</div>';
    loadBrand(handle, function (products) {
      /* only the newest request may paint; works for row brands AND More Brands picks */
      if (currentHandle === handle && !panel.hidden) renderBrand(brand, handle, buildTree(products));
    }, function () {
      if (currentHandle !== handle || panel.hidden) return;
      panel.innerHTML = '<div class="sp-bm-error">Couldn\u2019t load ' + esc(brand) + ' parts right now \u2014 <a href="/collections/' + esc(handle) + '">open the full ' + esc(brand) + ' collection instead \u2192</a></div>';
    });
  };

  var renderBrand = function (brand, handle, tree) {
    if (!tree.total) {
      panel.innerHTML = '<div class="sp-bm-error">No ' + esc(brand) + ' parts are showing yet \u2014 <a href="/collections/' + esc(handle) + '">open the ' + esc(brand) + ' collection \u2192</a><br><small>(If you just imported the data files, give the collections a minute to populate.)</small></div>';
      return;
    }
    var rail = '';
    for (var i = 0; i < tree.list.length; i++) {
      rail += '<button type="button" class="sp-bm-pt" data-i="' + i + '"><span>' + esc(tree.list[i].name) + '</span><small>' + tree.list[i].products.length + '</small></button>';
    }
    panel.innerHTML =
      '<div class="sp-bm-grid">' +
        '<div class="sp-bm-pts">' +
          '<div class="sp-bm-pts-head"><strong>' + esc(brand) + '</strong><a href="/collections/' + esc(handle) + '">All ' + tree.total + ' parts \u2192</a></div>' +
          '<div class="sp-bm-pts-sub">' + tree.list.length + ' part types \u00b7 most stocked first</div>' +
          rail +
        '</div>' +
        '<div class="sp-bm-prods"></div>' +
      '</div>';
    var pts = panel.querySelectorAll('.sp-bm-pt');
    var host = panel.querySelector('.sp-bm-prods');
    var pick = function (btn) {
      for (var j = 0; j < pts.length; j++) pts[j].classList.remove('is-on');
      btn.classList.add('is-on');
      renderCards(host, brand, handle, tree.list[+btn.getAttribute('data-i')], false);
      host.scrollTop = 0;
    };
    for (var k = 0; k < pts.length; k++) {
      pts[k].addEventListener('click', function () { pick(this); });
    }
    if (pts.length) pick(pts[0]);
  };

  var cardHtml = function (p) {
    var img = CFG.showImages
      ? '<span class="sp-bm-card-img">' + (p.img ? '<img src="' + esc(imgUrl(p.img, 200)) + '" alt="" loading="lazy">' : '<svg viewBox="0 0 24 24" fill="none" stroke="#c9c9c9" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>') + '</span>'
      : '';
    var chip = p.available ? '' : '<span class="sp-bm-chip">Out of stock</span>';
    var price = (CFG.showPrices && p.price !== null) ? '<span class="sp-bm-card-price">' + money(p.price) + '</span>' : '';
    return '<a class="sp-bm-card' + (p.available ? '' : ' is-out') + '" href="' + esc(p.url) + '">' + img +
      '<span class="sp-bm-card-title">' + esc(p.title) + '</span>' + price + chip + '</a>';
  };

  var renderCards = function (host, brand, handle, entry, showAll) {
    var list = entry.products;
    var n = showAll ? list.length : Math.min(CFG.maxInitial, list.length);
    var html = '<div class="sp-bm-view-head"><strong>' + esc(entry.name) + '</strong><span>' + list.length + (list.length === 1 ? ' part' : ' parts') + '</span><a href="/collections/' + esc(handle) + '/' + esc(handleize('pt:' + entry.raw)) + '">View all in collection \u2192</a></div>' +
      '<div class="sp-bm-cards" style="--sp-bm-cols:' + CFG.cols + ';">';
    for (var i = 0; i < n; i++) html += cardHtml(list[i]);
    html += '</div>';
    if (!showAll && list.length > n) {
      html += '<button type="button" class="sp-bm-showmore">Show ' + (list.length - n) + ' more</button>';
    }
    host.innerHTML = html;
    var more = host.querySelector('.sp-bm-showmore');
    if (more) more.addEventListener('click', function () { renderCards(host, brand, handle, entry, true); });
  };

  var renderMoreBrands = function () {
    currentHandle = null;
    var html = '<div class="sp-bm-morewrap"><div class="sp-bm-pts-head" style="margin-bottom:10px;"><strong>All Brands</strong></div><div class="sp-bm-moregrid">';
    for (var i = 0; i < moreBrands.length; i++) {
      html += '<button type="button" class="sp-bm-morebrand" data-brand="' + esc(moreBrands[i].name.toUpperCase()) + '" data-handle="' + esc(moreBrands[i].handle) + '">' + esc(moreBrands[i].name) + '</button>';
    }
    html += '</div></div>';
    panel.innerHTML = html;
    var btns = panel.querySelectorAll('.sp-bm-morebrand');
    for (var j = 0; j < btns.length; j++) {
      btns[j].addEventListener('click', function () {
        renderBrandLoading(this.getAttribute('data-brand'), this.getAttribute('data-handle'));
      });
    }
  };

  for (var i = 0; i < triggers.length; i++) {
    triggers[i].addEventListener('click', function () { openFor(this); });
  }
  /* Outside-close: capture phase runs BEFORE the button's own handler re-renders
     the panel, so the clicked node is still attached when we test containment.
     The detached-node guard covers any other in-panel re-render path. */
  document.addEventListener('click', function (e) {
    if (panel.hidden) return;
    if (root.contains(e.target)) return;
    if (!document.contains(e.target)) return; /* node removed by a re-render = it was inside the panel */
    closePanel();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) { var b = activeBtn; closePanel(); if (b) b.focus(); }
  });

  /* ---------------- mobile sheet ---------------- */
  var sheetState = { view: 'brands', brand: null, handle: null, tree: null, entry: null, showAll: false };

  var sheetShell = function (title, backView) {
    return '<div class="sp-bms-head">' +
      (backView ? '<button type="button" class="sp-bms-back" data-back="' + backView + '" aria-label="Back"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' : '<span class="sp-bms-back-spacer"></span>') +
      '<strong>' + esc(title) + '</strong>' +
      '<button type="button" class="sp-bms-close" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
    '</div><div class="sp-bms-body"></div>';
  };

  var sheetRender = function () {
    var titles = { brands: 'Shop by Brand', pts: sheetState.brand || 'Part Types', prods: (sheetState.entry && displayName(sheetState.entry.raw)) || 'Products' };
    var backs = { brands: null, pts: 'brands', prods: 'pts' };
    sheet.innerHTML = sheetShell(titles[sheetState.view], backs[sheetState.view]);
    var body = sheet.querySelector('.sp-bms-body');

    if (sheetState.view === 'brands') {
      var html = '<div class="sp-bms-sub">Main brands</div>';
      for (var i = 0; i < triggers.length; i++) {
        if (triggers[i].getAttribute('data-more')) continue;
        html += '<button type="button" class="sp-bms-row" data-brand="' + esc(triggers[i].getAttribute('data-brand')) + '" data-handle="' + esc(triggers[i].getAttribute('data-handle')) + '"><span>' + esc(triggers[i].getAttribute('data-brand')) + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>';
      }
      html += '<div class="sp-bms-sub">More brands</div>';
      for (var m = 0; m < moreBrands.length; m++) {
        html += '<button type="button" class="sp-bms-row" data-brand="' + esc(moreBrands[m].name.toUpperCase()) + '" data-handle="' + esc(moreBrands[m].handle) + '"><span>' + esc(moreBrands[m].name) + '</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>';
      }
      body.innerHTML = html;
      var rows = body.querySelectorAll('.sp-bms-row');
      for (var r = 0; r < rows.length; r++) {
        rows[r].addEventListener('click', function () {
          sheetState.brand = this.getAttribute('data-brand');
          sheetState.handle = this.getAttribute('data-handle');
          sheetState.tree = null;
          sheetState.allTypes = false;
          sheetState.view = 'pts';
          sheetRender();
        });
      }
    }

    if (sheetState.view === 'pts') {
      if (!sheetState.tree) {
        body.innerHTML = '<div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div><div class="sp-bm-skel-row"></div>';
        loadBrand(sheetState.handle, function (products) {
          if (sheetState.view === 'pts') { sheetState.tree = buildTree(products); sheetRender(); }
        }, function () {
          body.innerHTML = '<div class="sp-bm-error">Couldn\u2019t load right now \u2014 <a href="/collections/' + esc(sheetState.handle) + '">open the full collection \u2192</a></div>';
        });
        return;
      }
      var t = sheetState.tree;
      var shownT = sheetState.allTypes ? t.list.length : Math.min(TOP_TYPES, t.list.length);
      var h = '<a class="sp-bms-all" href="/collections/' + esc(sheetState.handle) + '">All ' + t.total + ' ' + esc(sheetState.brand) + ' parts \u2192</a>';
      h += '<div class="sp-bms-sub">' + (sheetState.allTypes || t.list.length <= TOP_TYPES ? 'All part types' : 'Top ' + shownT + ' part types') + '</div>';
      for (var e2 = 0; e2 < shownT; e2++) {
        h += '<button type="button" class="sp-bms-row" data-i="' + e2 + '"><span>' + esc(t.list[e2].name) + '</span><small>' + t.list[e2].products.length + '</small></button>';
      }
      if (t.list.length > shownT) {
        h += '<button type="button" class="sp-bm-showmore" id="sp-bms-more-types">Show ' + (t.list.length - shownT) + ' more part types</button>';
      }
      body.innerHTML = h;
      var prows = body.querySelectorAll('.sp-bms-row');
      for (var p2 = 0; p2 < prows.length; p2++) {
        prows[p2].addEventListener('click', function () {
          sheetState.entry = t.list[+this.getAttribute('data-i')];
          sheetState.showAll = false;
          sheetState.view = 'prods';
          sheetRender();
        });
      }
      var mt = document.getElementById('sp-bms-more-types');
      if (mt) mt.addEventListener('click', function () { sheetState.allTypes = true; sheetRender(); });
    }

    if (sheetState.view === 'prods') {
      var entry = sheetState.entry;
      var list = entry.products;
      var n = sheetState.showAll ? list.length : Math.min(CFG.maxInitial, list.length);
      var ph = '<div class="sp-bms-count">' + list.length + (list.length === 1 ? ' part' : ' parts') + ' \u00b7 <a href="/collections/' + esc(sheetState.handle) + '/' + esc(handleize('pt:' + entry.raw)) + '">view in collection \u2192</a></div>';
      for (var c = 0; c < n; c++) {
        var p3 = list[c];
        ph += '<a class="sp-bms-card' + (p3.available ? '' : ' is-out') + '" href="' + esc(p3.url) + '">' +
          (CFG.showImages ? '<span class="sp-bms-thumb">' + (p3.img ? '<img src="' + esc(imgUrl(p3.img, 120)) + '" alt="" loading="lazy">' : '') + '</span>' : '') +
          '<span class="sp-bms-info"><span class="sp-bms-title">' + esc(p3.title) + '</span>' +
          ((CFG.showPrices && p3.price !== null) ? '<span class="sp-bms-price">' + money(p3.price) + '</span>' : '') +
          (p3.available ? '' : '<span class="sp-bm-chip">Out of stock</span>') +
          '</span></a>';
      }
      if (!sheetState.showAll && list.length > n) {
        ph += '<button type="button" class="sp-bm-showmore" id="sp-bms-more">Show ' + (list.length - n) + ' more</button>';
      }
      body.innerHTML = ph;
      var mb = document.getElementById('sp-bms-more');
      if (mb) mb.addEventListener('click', function () { sheetState.showAll = true; sheetRender(); });
    }

    var back = sheet.querySelector('.sp-bms-back');
    if (back) back.addEventListener('click', function () { sheetState.view = this.getAttribute('data-back'); sheetRender(); });
    sheet.querySelector('.sp-bms-close').addEventListener('click', sheetHide);
  };

  var sheetShow = function () {
    sheetState = { view: 'brands', brand: null, handle: null, tree: null, entry: null, showAll: false, allTypes: false };
    sheet.hidden = false;
    document.body.classList.add('sp-bms-lock');
    sheetRender();
  };
  var sheetHide = function () {
    sheet.hidden = true;
    sheet.innerHTML = '';
    document.body.classList.remove('sp-bms-lock');
    if (mobileOpen) mobileOpen.focus();
  };
  if (mobileOpen) mobileOpen.addEventListener('click', sheetShow);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden) sheetHide();
  });

  /* Theme Editor re-renders sections; make sure nothing stays open */
  document.addEventListener('shopify:section:load', function () {
    closePanel();
    if (sheet && !sheet.hidden) sheetHide();
  });
})();
